import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import React from "react";

import ErrorElement from "../../commonComponent/ErrorElement";
import { FormSubSections, ProgramContainer, RedirectSection } from "../../entities/formTemplateDataType";
import { SubmissionMethodList } from "../../entities/Constants";
import { DialogBase } from "./DialogBase";

interface Props {
    programContainer: ProgramContainer
    isEng: boolean;
    dialogVisible: boolean;
    callback;
}

interface State {
	pickedFieldOptions;
	statusCodeError?: string;
	statusCodeValue?: string;
	redirectPage?: RedirectSection;
}

export class DialogForPageRedirectComponent extends DialogBase<Props, State> {
	constructor(props: Props) {
		super(props);

		this.state = {
				pickedFieldOptions: [],
		};
	}

	handleStatusCodeChange = (e) => {
        const regex = /^[a-zA-Z0-9_-]+$/;
		const value = e.target.value as string;
		if (!value) {
			this.setState({ statusCodeError: "Status code is required" });
		} else if (!regex.test(value)) {
            this.setState({ statusCodeError: "Only alphanumeric is allowed" });
		} else {
			this.setState({ statusCodeError: undefined, statusCodeValue: value });
		}
	}

	addRoutingPage = (e) => {
		e.preventDefault();
		if (this.state.statusCodeValue && this.state.redirectPage?.redirectPage) {
				const statusCode = this.state.statusCodeValue?.trim();
				this.setState({statusCodeError: undefined});
				const route = this.state.redirectPage;
				route.statusCode = statusCode;
				this.props.programContainer.PageRedirection = this.props.programContainer.PageRedirection || {};
				this.props.programContainer.PageRedirection.apiSuccessRedirectPage = this.props.programContainer.PageRedirection.apiSuccessRedirectPage || [];
				this.props.programContainer.PageRedirection.apiSuccessRedirectPage.push(route);
				this.setState({statusCodeValue: undefined, redirectPage: undefined});
				this.props.callback();
		} else {
						this.setState({statusCodeError: "status code is required"});
		}			
	}

	generateContentString = () => {
		let elementListWithOptions = [];
		const sectionIndex = this.props.programContainer.ListOfFormSections.map(section => {
        return {sequence: section.Sequence, title: section.ENUTitle };
    });

		let subSection = this.props.programContainer.ListOfFormSections[0]?.ListOfFormSubSections[0] as FormSubSections;

		let list = subSection?.ListOfFormSectionElements.filter(
				(q) =>
				(q.Datatype === "RadioButton" ||
						q.Datatype === "CheckGroup" ||
						q.Datatype === "Dropdown")
		).map((q) => {
				return {
						code: this.props.isEng
								? q.ENUTitle?.replace(/\s/g, "")
								: q.FRATitle?.replace(/\s/g, ""),
						description: this.props.isEng ? q.ENUTitle : q.FRATitle
				};
		});
		elementListWithOptions.push(...list);

		let htmlString = [];
		htmlString.push(
		<div style={{ width: "100%", paddingTop: "5px" }}>
			<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>API</div>
					<div style={{ width: '60%'}}>                  
						<InputText className="ontario-input" 
							value={this.props.programContainer.PageRedirection?.api} 
							onChange={(e) => {
								this.props.programContainer.PageRedirection.api = e.target.value;
								this.props.programContainer.PageRedirection = {...this.props.programContainer.PageRedirection ?? {}, api: e.target.value };
								this.props.callback();
							}}/>
					</div>
			</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
						<div style={{ width: '25%' }}>API-Key:</div>
						<div style={{ width: '60%', marginTop: '5px' }}>
							<div >
								<InputText className="ontario-input"
										value={this.props.programContainer.PageRedirection?.apiKeyKey}
										placeholder="Key"
										title="API-Key Key"
										onChange={(e) => {
											this.props.programContainer.PageRedirection.apiKeyKey = e.target.value;
											this.props.programContainer.PageRedirection = { ...this.props.programContainer.PageRedirection ?? {}, apiKeyKey: e.target.value };
											this.props.callback();
										}}/>
							</div>
							<div>
								<InputText className="ontario-input"
										value={this.props.programContainer.PageRedirection?.apiKeyValue}
										placeholder="Value"
										title="API-Key Value"
										onChange={(e) => {
											this.props.programContainer.PageRedirection.apiKeyValue = e.target.value;
											this.props.programContainer.PageRedirection = { ...this.props.programContainer.PageRedirection ?? {}, apiKeyValue: e.target.value };
											this.props.callback();
										}}/>
							</div>
						</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Method</div>
					<div style={{ width: '60%', marginTop: '5px' }}>
						<Dropdown style={{ width: '100%' }} showClear
							className="ontario-dropdown-small"
							options={SubmissionMethodList}
							value={this.props.programContainer.PageRedirection?.SubmissionMethod}
							optionLabel='label'
							optionValue='val'
							placeholder="SubmissionMethod"
							onChange={(e) => {
								this.props.programContainer.PageRedirection.SubmissionMethod = e.value;
								this.props.programContainer.PageRedirection = {...this.props.programContainer.PageRedirection ?? {}, SubmissionMethod: e.value };
								this.props.callback();
							}}/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Response field name:</div>
					<div style={{ width: '60%', marginTop: '5px' }}>
						<InputText className="ontario-input" 
							value={this.props.programContainer.PageRedirection?.responseDataName} 
							onChange={(e) => {
									this.props.programContainer.PageRedirection.api = e.target.value;
									this.props.programContainer.PageRedirection = {...this.props.programContainer.PageRedirection ?? {}, responseDataName: e.target.value };
									this.props.callback();
							}}/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>API error redirect to:</div>
					<div style={{ width: '60%', marginTop: '5px' }}>
							{/* @ts-ignore */}
							<Dropdown style={{ width: '100%' }} showClear
								className="ontario-dropdown-small"
								options={sectionIndex}
								value={this.props.programContainer.PageRedirection?.apiErrorRedirectPage}
								optionLabel='title'
								optionValue='sequence'
								placeholder="Page to redirect to"
								onChange={(e) => {
									const sequence = Number(e.value);
									this.props.programContainer.PageRedirection = {...this.props.programContainer.PageRedirection ?? {}, apiErrorRedirectPage: isNaN(sequence) ? undefined : sequence};
									this.props.callback();
								}}/>
						</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>Max API attempts:</div>
					<div style={{ width: '60%', marginTop: '5px' }}>
						<InputText className="ontario-input" 
								type="number"
								min="1"
								max="10"
								value={String(this.props.programContainer.PageRedirection?.maxApiAttempts || '')} 
								onChange={(e) => {
									const attempts = Number(e.target.value);
									this.props.programContainer.PageRedirection = {...this.props.programContainer.PageRedirection ?? {}, maxApiAttempts: isNaN(attempts) || attempts < 1 ? 1 : attempts};
									this.props.callback();
								}}/>
					</div>
				</div>
				<div style={{ display: "flex", marginTop: '10px' }}>
					<div style={{ width: '25%' }}>API success routes:</div>
					<div style={{ width: '60%', marginTop: '5px' }}>
						<div style={{ width: '100%', marginTop: '5px' }}>
							{this.props.programContainer.PageRedirection?.apiSuccessRedirectPage?.length > 0 && (
									<table style={{ width: '100%' }}>
											<tbody>
													{this.props.programContainer.PageRedirection?.apiSuccessRedirectPage?.map((item, index) => {
															return (
																	<tr key={`success-routing-${index}`}>
																			<td style={{ width: '20%' }}>
																					{item.statusCode}
																			</td>
																			<td style={{ width: '50%' }}>
																					{item.title}
																			</td>
																			<td style={{ width: '30%' }}>
																					<Button label="Delete" icon="pi pi-times" onClick={(e) => {
																							e.preventDefault();
																							this.props.programContainer.PageRedirection.apiSuccessRedirectPage.splice(index, 1);
																							this.props.callback();
																					}} />
																			</td>
																	</tr>
															)
													})}
											</tbody>
									</table>
								)}										
						</div>
						<ErrorElement
								display={!!this.state.statusCodeError}
								message={this.state.statusCodeError}/>
						<div style={{ width: '100%', marginTop: '5px', display: 'flex', justifyContent: 'space-between' }}>
							<>
								<InputText className="ontario-input"
										style={{ width: '20%' }}
										value={this.state.statusCodeValue || ''}
										maxLength={10}
										placeholder="Status code"
										onChange={this.handleStatusCodeChange}/>
								
									<Dropdown style={{ width: '50%' }} showClear
											className="ontario-dropdown-small"
											options={sectionIndex}
											value={this.state.redirectPage?.redirectPage}
											optionLabel='title'
											optionValue='sequence'
											placeholder="Page to redirect to"
											onChange={(e) => {
												const sequence = Number(e.value)
												const section = sectionIndex?.filter(p => p.sequence === sequence)[0];
												this.setState({redirectPage: { redirectPage: isNaN(sequence) ? undefined : sequence, title: section.title, statusCode: this.state.statusCodeValue ? this.state.statusCodeValue.trim() : undefined }});
												this.props.callback();
											}}/>
									<Button style={{width: '30%'}} label="Add" onClick={(e) => {this.addRoutingPage(e)}} />
								</>
						</div>
					</div>
				</div>
			</div>
		);

		return htmlString;
	};

	renderFooter = () => {
		return (
			<div>
				<Button label="OK" icon="pi pi-check" onClick={() => {
						this.props.callback(false);
				}} />
				<Button label="Cancel" onClick={() => { this.props.callback(false) }} />
			</div>
		);
	}

	generateHtmlString = () => {
		let html = [];
		html.push(
			<>
				<Dialog 
					header={this.props.isEng ? "Page Redirection" : "Redirection de pages"} 
					footer={this.renderFooter()}
					visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
					{this.generateContentString()}
				</Dialog>
			</>
		);
		return html;
	}

	render() {
		return (
				<>
						{this.generateHtmlString()}
				</>
		);
	}
}